import React, {useState} from "react";
import {getObjectFromArrayOfObjects} from "../../../../_helpers/helperFunctions";
import SearchTable from "../../../primer/Search-Table";

const SearchICD10s = () => {
    const searchFilters = {
        filters: [
            {
                name: "filter",
                label: "Φίλτρο κωδικού/περιγραφής",
                type: "input",
            },
        ],
        actions: [],
    }

    const searchColumns = [
        {
            name: "Κωδικός",
            field: "code",
            editable: false,
            width: "15%",
            inputType: {
                type: "text",
            }
        },
        {
            name: "Τίτλος",
            field: "title",
            editable: false,
            width: "25%",
            inputType: {
                type: "text",
            }
        },
        {
            name: "Περιγραφή",
            field: "description",
            editable: false,
            width: "60%",
            inputType: {
                type: "text",
            }
        },
    ]

    const [tableColumns, setTableColumns] = useState(searchColumns.slice());

    const handleColumnShowHide = (field) => {
        let tempTc = tableColumns.slice();
        let object = getObjectFromArrayOfObjects(tempTc, field, 'field')
        const index = tempTc.findIndex((item) => field === item.field);
        if (object.length > 0) {
            tempTc[index].hiddenColumn = !object['0'].hiddenColumn;
            setTableColumns(tempTc);
        }
    }

    return (
        <div>
            <SearchTable
                tableName={"Prescription Search ICD10s"}
                key={"Prescription Search ICD10s"}
                hideYearFilter={true}
                allowPagination={true}
                allowToggleColumns={true}
                showDummyData={false}
                columns={tableColumns}
                toggleColumns={handleColumnShowHide}
                allowSelectionCheckbox={false}
                data={[]}
                filtersConfig={searchFilters}
                allowSorting={false}
            />
        </div>
    )
}

export default SearchICD10s;
